import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { createWebPageSchema } from "../lib/seo";
import styles from "./NotFound.module.css";

const seo = {
  title: "Page Not Found | PSP RCM",
  description:
    "The page you are looking for could not be found. Browse PSP RCM services, insights, and healthcare support pages.",
  keywords: "404, page not found, PSP RCM",
  schema: [
    createWebPageSchema({
      path: "/404",
      title: "Page Not Found",
      description:
        "The page you are looking for could not be found. Browse PSP RCM services, insights, and healthcare support pages.",
    }),
  ],
};

export default function NotFound() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalPath="/404"
        schema={seo.schema}
        noIndex
      />
      <section className={styles.section}>
        <div className={`container ${styles.shell}`}>
          <span className={styles.code}>404</span>
          <h1>Page Not Found</h1>
          <p>
            The page you are looking for may have been moved, removed, or the link may be incorrect.
          </p>
          <div className={styles.actions}>
            <Link to="/" className={styles.primaryAction}>
              Back To Home
            </Link>
            <Link to="/contact-us" className={styles.secondaryAction}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
